import axios from 'axios'
import { storeAllEntities } from '@/helpers/store'
import qs from 'qs'
import * as api from '@/employees/api'

const getDefaultEventState = () => {
  return {
    events: {},
    event_students: {},
    student_event_contexts: {},
    assessment_configs: {},
  }
}

export default {
  state: getDefaultEventState,
  mutations: {
    RESET_EVENT_STATE (state) {
      Object.assign(state, getDefaultEventState())
    },
    ADD_CHILD_EVENT (state, { parentEventId, childEventId }) {
      state.events[parentEventId].childEvents.push(childEventId)
    },
    ADD_ASSESSMENT_CONFIG_TO_EVENT(state, {eventId, assessmentConfigId}) {
      Vue.set(state.events[eventId], 'assessmentConfig', assessmentConfigId)
    },
    DELETE_EVENT(state, {eventId}) {
      delete state.events[eventId]
    },
    DELETE_EVENT_FROM_PARENT (state, {eventId, parentEventId}) {
      const parentEvent = state.events[parentEventId]

      if(parentEvent?.childEvents != null) {
        parentEvent.childEvents = parentEvent.childEvents.filter(id => id !== eventId)
        Vue.set(state.events, parentEventId, parentEvent)
      }
    }
  },
  actions: {
    resetEventState ({ commit, state }) {
      commit('RESET_EVENT_STATE')
    },
    getCourseMatrixLessons ({ commit, state }, { courseId }) {
      return axios.get(`/employee/courses/${courseId}/lessons/matrix/lesson-api`).then(storeAllEntities(commit))
    },
    getCourseMatrixStudents ({ commit, state }, { courseId, queryParams = null }) {
      return axios.get(`/employee/courses/${courseId}/lessons/matrix/student-api`, {
        params: queryParams,
        paramsSerializer: params => {
          return qs.stringify(params)
        },
      }).then(storeAllEntities(commit))
    },
    getCourseMatrixLessonDetails ({ commit, state }, { courseId, queryParams = null }) {
      return axios.get(`/employee/courses/${courseId}/lessons/matrix/api`, {
        params: queryParams,
        paramsSerializer: params => {
          return qs.stringify(params)
        },
      }).then(storeAllEntities(commit))
    },
    exportCourseMatrixLessons ({ commit, state }, { courseId, queryParams = null }) {
      return axios.post(`/employee/courses/${courseId}/lessons/matrix/export`, {
        params: queryParams,
        paramsSerializer: params => {
          return qs.stringify(params)
        },
      })
    },
    getGroupMatrixLessons ({ commit, state }, { groupId }) {
      return axios.get(`/employee/groups/${groupId}/lessons/matrix/lesson-api`).then(storeAllEntities(commit))
    },
    getGroupMatrixStudents ({ commit, state }, { groupId }) {
      return axios.get(`/employee/groups/${groupId}/lessons/matrix/student-api`).then(storeAllEntities(commit))
    },
    getGroupMatrixLessonDetails ({ commit, state }, { groupId, queryParams = null }) {
      return axios.get(`/employee/groups/${groupId}/lessons/matrix/api`, {
        params: queryParams,
        paramsSerializer: params => {
          return qs.stringify(params)
        },
      }).then(storeAllEntities(commit))
    },
    exportGroupMatrixLessons ({ commit, state }, { groupId, queryParams = null }) {
      return axios.post(`/employee/groups/${groupId}/lessons/matrix/export`, {
        params: queryParams,
        paramsSerializer: params => {
          return qs.stringify(params)
        },
      })
    },
    getMatrixLessons ({ commit }) {
      return axios.get('/employee/my-students/attendances/matrix/lesson-api').then(storeAllEntities(commit))
    },
    getMatrixStudents ({ commit }) {
      return axios.get('/employee/my-students/attendances/matrix/student-api').then(storeAllEntities(commit))
    },
    getMatrixLessonDetails ({ commit }, { queryParams = null }) {
      return axios.get('/employee/my-students/attendances/matrix/api', {
        params: queryParams,
        paramsSerializer: params => {
          return qs.stringify(params)
        },
      }).then(storeAllEntities(commit))
    },
    exportMatrixLessons ({ _ }, { queryParams = null }) {
      return axios.post('/employee/my-students/attendances/matrix/export', {
        params: queryParams,
        paramsSerializer: params => {
          return qs.stringify(params)
        },
      })
    },
    getEvent ({ commit }, { eventId, queryParams }) {
      return api.getEvent(eventId, queryParams)
        .then(storeAllEntities(commit))
    },
    updateEvent ({ commit }, { eventId, data }) {
      return api.updateEvent(eventId, data)
        .then(storeAllEntities(commit))
    },
    deleteEvent({commit}, {eventId, parentEventId}) {
      return api.deleteEvent(eventId)
        .then((resources) => {
          if(parentEventId != null) {
            commit('DELETE_EVENT_FROM_PARENT', {eventId, parentEventId})
          }
          commit('DELETE_EVENT', eventId)
          return resources
        })
    },
    createAssessmentConfig ({ commit }, { eventId, data }) {
      return api.createAssessmentConfig(eventId, data)
        .then(storeAllEntities(commit))
        .then((resources) => {
          commit('ADD_ASSESSMENT_CONFIG_TO_EVENT', { eventId: eventId, assessmentConfigId: resources.primaryResources[0].id })
        })
    },
    updateAssessmentConfig ({ commit }, { assessmentConfigId, data }) {
      return api.updateAssessmentConfig(assessmentConfigId, data)
        .then(storeAllEntities(commit))
    },
    generateAssessmentConfigEvents ({ commit }, { assessmentConfigId, data }) {
      return api.generateAssessmentConfigEvents(assessmentConfigId, data)
        .then(storeAllEntities(commit))
    },
    addAssessmentConfigEvent ({ commit }, { assessmentConfigId, parentEventId, data }) {
      return api.addAssessmentConfigEvent(assessmentConfigId, data)
        .then(storeAllEntities(commit))
        .then((response) => {
          commit('ADD_CHILD_EVENT', { parentEventId, childEventId: response.events[0].id })
          return response
        })
    },
    moveStudentToEvent ({ commit }, { data }) {
      return api.moveStudentToEvent(data)
        .then(storeAllEntities(commit))
    },
    finalizeEventAssessmentConfig ({ commit }, { assessmentConfigId, data }) {
      return api.finalizeEventAssessmentConfig(assessmentConfigId, data)
        .then(storeAllEntities(commit))
    },
  },
  getters: {},
}
